// extracted by mini-css-extract-plugin
export default {"container":"Search_container__BSbg1","openedContainer":"Search_openedContainer__cIcHK"};